module.exports = __webpack_public_path__ + "img/pluralsight-practical-html5.2f75cb3f.png";